module.exports = __webpack_public_path__ + "assets/images/$5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/$5.png
// module id = 1248
// module chunks = 1